import { call, put, all, spawn, takeEvery, debounce } from 'redux-saga/effects';
import request from 'utils/request';
import { SEARCH_EASY_SPLIT_VENDOR_ALL_URL } from 'utils/constants';
import {
  VENDOR_DATA_BY_ID_URL,
  GET_SPLIT_VENDOR_OPTIONS_URL,
  FETCH_EASY_SPLIT_CONFIG_URL,
} from 'constants/url';

import { showToast } from '../Toast/actions';
import {
  saveEasySplitVendorsAction,
  disableLoaderAction,
  batchUploadSaveResponseAction,
  createVendorSaveResponseAction,
  updateVendorSaveResponseAction,
  saveSettlementConfigAction,
  saveVendorDataByIdAction,
  saveVendorDocsAction,
} from './actions';

import {
  SEARCH_VENDORS,
  BATCH_UPLOAD_URL,
  BATCH_UPLOAD_SUBMIT,
  BATCH_DOWNLOAD,
  CREATE_VENDOR,
  UPDATE_VENDOR,
  SETTLEMENT_CONFIG,
  UPDATE_VENDOR_FIELDS,
  CREATE_VENDOR_URL,
  UPDATE_VENDOR_URL,
  VENDOR_DATA_BY_ID,
  BATCH_DOWNLOAD_URL,
  GET_VENDOR_OD_BALANCE,
  INITIATE_VENDOR_OD,
  GET_VENDOR_OD_BALANCE_URL,
  INITIATE_VENDOR_OD_URL,
  MINIMUM_VENDOR_BALANCE,
  SPLIT_VENDOR_EXIST_ERROR,
  CREATE_KYC,
  CREATE_KYC_URL,
  DOWNLOAD_DOC_URL,
  DOWNLOAD_DOC,
  CREATE_VENDOR_URL_NEW,
  GET_VENDOR_KYC_DOCS_URL,
  GET_VENDOR_KYC_DOCS,
  GET_BUSINESS_INFO,
  UPDATE_VENDOR_URL_NEW,
  IN_BENE_UPDATE_VENDOR_FIELDS,
  IN_BENE_CREATION,
  CREATE_VENDOR_NEW,
  UPDATE_VENDOR_NEW,
  GET_DOCS_BY_USER_URL,
  GET_DOCS_BY_USER,
  UPLOAD_VENDOR_DOCS_URL,
  UPLOAD_VENDOR_DOCS,
  VERIFY_PAN_URL,
  VERIFY_CIN_URL,
  VERIFY_GST_URL,
  VERIFY_PAN,
  VERIFY_GST,
  VERIFY_CIN,
  CREATE_ONBOARDING_USER_URL,
  CREATE_ONBOARDING_USER,
} from './constants';

export function* searchEasySplitVendors({ data }) {
  try {
    const { activeNavigation, options: reqOptions } = data;
    const { url, method } = SEARCH_EASY_SPLIT_VENDOR_ALL_URL;
    const options = { method, queryString: reqOptions || {} };
    const response = yield call(request, url, options);
    yield put(saveEasySplitVendorsAction({ data: response, activeNavigation }));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getSettlementConfig() {
  try {
    const promiseArr = [
      GET_SPLIT_VENDOR_OPTIONS_URL,
      FETCH_EASY_SPLIT_CONFIG_URL,
    ].map(
      obj => call(request, obj.url, { method: obj.method }), // eslint-disable-line
    );
    const [settlementConfig, vendorOdConfig] = yield all(promiseArr);
    yield put(saveSettlementConfigAction({ settlementConfig, vendorOdConfig }));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* batchUploadSubmit({ data: { data, cb, resolve } }) {
  try {
    const formData = new FormData();
    formData.append('file', data, data.name);
    const { url, method } = BATCH_UPLOAD_URL;
    const options = {
      method,
      headers: {},
      body: formData,
    };
    const response = yield call(request, url, options);
    if (
      response &&
      response.failedCreateBatchVendors &&
      response.failedCreateBatchVendors.length > 0
    ) {
      cb(response.failedCreateBatchVendors, data);
      yield put(
        showToast({
          message: 'Error Log downloaded successfully',
          type: 'SUCCESS',
        }),
      );
    }
    yield put(batchUploadSaveResponseAction(response));
    resolve({ ...response, ...data });
  } catch (err) {
    if (err.errorMeta && err.errorMeta.errors) {
      yield put(batchUploadSaveResponseAction(err.errorMeta));
    }
    resolve({ error: err });
  }
}

export function* batchDownload({ data: { cb, fileId } }) {
  try {
    const { url, method } = BATCH_DOWNLOAD_URL;
    const updatedUrl = url.replace('$file_id$', fileId);
    const { signedUrl } = yield call(request, updatedUrl, { method });
    cb(signedUrl);
    yield put(disableLoaderAction());
  } catch (e) {
    yield put(disableLoaderAction());
    yield put(showToast(e));
  }
}

export function* createKyc({
  payload: { actions, cb, data, errCb, updatedBy, merchantVendorId },
}) {
  try {
    const promiseArr = [];
    const { url, method } = CREATE_KYC_URL;
    const updatedUrlForVendorById = url.replace(
      '$vendor_id$',
      merchantVendorId,
    );
    if (data) {
      const keys = Object.keys(data);
      keys.forEach(key => {
        if (data[key].type && data[key].size / (1024 * 1024) <= 25) {
          const fieldName = key;
          const file = data[key];
          const formData = new FormData();
          formData.append('file', file, file.name);
          formData.append('docType', fieldName);
          formData.append('updatedBy', updatedBy);
          promiseArr.push(
            // eslint-disable-next-line redux-saga/yield-effects
            call(request, updatedUrlForVendorById, { method, body: formData }),
          );
        }
      });
      yield all(promiseArr);
    }
    cb();
    disableLoaderAction();
  } catch (err) {
    actions.setSubmitting(false);
    yield put(disableLoaderAction());
    if (err) errCb();
  }
}
export function* downloadDoc({ data: { data, cb } }) {
  try {
    const { docType, merchantVendorId } = data;
    const { url, method } = DOWNLOAD_DOC_URL;
    const updatedUrl = url.replace('$vendor_id$', merchantVendorId);
    const updatedUrlForDocDownload = updatedUrl.replace('$docType$', docType);
    const options = {
      method,
    };
    const response = yield call(request, updatedUrlForDocDownload, options);
    cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    showToast(err);
  }
}

export function* createVendor({ payload: { actions, cb, data, errorCb } }) {
  try {
    const { url, method } = CREATE_VENDOR_URL;
    const options = {
      method,
      body: JSON.stringify(data),
    };
    const response = yield call(request, url, options);
    yield put(createVendorSaveResponseAction(response));
    yield put(
      showToast({
        message: 'Vendor Added Successfully!',
        type: 'SUCCESS',
      }),
    );
    cb();
  } catch (err) {
    actions.setSubmitting(false);
    yield put(disableLoaderAction());
    let formattedError = err;
    if (
      err &&
      err.errorMeta &&
      err.errorMeta.title === SPLIT_VENDOR_EXIST_ERROR
    ) {
      formattedError = new Error('VendorId already exists');
    }
    if (errorCb) errorCb(formattedError);
  }
}
export function* updateVendor({
  payload: { data, actions, cb, statusChange, errorCb, showVendorDbToggle },
}) {
  try {
    const { url, method } = UPDATE_VENDOR_URL;
    const { merchantVendorId, ...body } = data;
    let responseVendorById = {};
    if (statusChange) {
      const { url: vendorByIdUrl } = VENDOR_DATA_BY_ID_URL;
      const updatedUrlForVendorById = vendorByIdUrl.replace(
        '$vendor_id$',
        merchantVendorId,
      );
      const optionsForVendorById = { method: VENDOR_DATA_BY_ID_URL.method };
      responseVendorById = yield call(
        request,
        updatedUrlForVendorById,
        optionsForVendorById,
      );
      responseVendorById.scheduleOption =
        responseVendorById.schedule &&
        responseVendorById.schedule.scheduleId.toString();
    }
    let payload = {};
    UPDATE_VENDOR_FIELDS.forEach(key => {
      payload[key] = body[key] || responseVendorById[key];
    });
    if (showVendorDbToggle) {
      const { dashboardAccess } = body;
      payload = { ...payload, dashboardAccess };
    }
    const updatedUrl = url.replace('$vendor_id$', merchantVendorId);
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    const response = yield call(request, updatedUrl, options);
    yield put(updateVendorSaveResponseAction(response));
    if (cb) {
      yield put(
        showToast({
          message: 'Vendor Updated Successfully!',
          type: 'SUCCESS',
        }),
      );
      cb();
    }
  } catch (err) {
    if (actions) actions.setSubmitting(false);
    if (errorCb) errorCb(err);
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* createVendorNew({
  payload: { actions, cb, data, errorCb, incrementalVendorOnboarding },
}) {
  try {
    const { url, method } = CREATE_VENDOR_URL_NEW;
    const formattedData = data;
    delete formattedData.showVendorDbToggle;
    const options = {
      method,
      body: JSON.stringify(formattedData),
    };
    const response = yield call(request, url, options);
    yield put(createVendorSaveResponseAction(response));
    yield put(
      showToast({
        message: 'Vendor Added Successfully!',
        type: 'SUCCESS',
      }),
    );
    cb(response);
  } catch (err) {
    actions.setSubmitting(false);
    yield put(disableLoaderAction());
    let formattedError = err;
    if (err?.errorMeta?.title === SPLIT_VENDOR_EXIST_ERROR) {
      formattedError = new Error('VendorId already exists');
      if (incrementalVendorOnboarding) {
        yield put(showToast(formattedError));
      }
    } else if (
      /^Account holder name matching failed/i.test(err?.errorMeta?.message)
    ) {
      actions.setFieldError('name', err?.errorMeta?.message);
    } else {
      yield put(showToast(err));
    }
    if (errorCb) errorCb(formattedError);
  }
}
export function* updateVendorNew({
  payload: { data, actions, cb, statusChange, errorCb, showVendorDbToggle },
}) {
  try {
    const { url, method } = UPDATE_VENDOR_URL_NEW;
    const { merchantVendorId, vendorStatus, ...body } = data;
    let responseVendorById = {};
    if (statusChange) {
      const { url: vendorByIdUrl } = VENDOR_DATA_BY_ID_URL;
      const updatedUrlForVendorById = vendorByIdUrl.replace(
        '$vendor_id$',
        merchantVendorId,
      );
      const optionsForVendorById = { method: VENDOR_DATA_BY_ID_URL.method };
      responseVendorById = yield call(
        request,
        updatedUrlForVendorById,
        optionsForVendorById,
      );
      responseVendorById.scheduleOption =
        responseVendorById.schedule &&
        responseVendorById.schedule.scheduleId.toString();
    }
    let payload = {};
    if (vendorStatus === IN_BENE_CREATION) {
      IN_BENE_UPDATE_VENDOR_FIELDS.forEach(key => {
        payload[key] = body[key] || responseVendorById[key];
      });
    } else {
      UPDATE_VENDOR_FIELDS.forEach(key => {
        payload[key] = body[key] || responseVendorById[key];
      });
    }
    if (showVendorDbToggle) {
      const { dashboardAccess } = body;
      payload = { ...payload, dashboardAccess };
    }
    const updatedUrl = url.replace('$vendor_id$', merchantVendorId);
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    const response = yield call(request, updatedUrl, options);
    yield put(updateVendorSaveResponseAction(response));
    if (cb) {
      yield put(
        showToast({
          message: 'Vendor Updated Successfully!',
          type: 'SUCCESS',
        }),
      );
      cb(response);
    }
  } catch (err) {
    yield put(showToast(err));
    if (actions) actions.setSubmitting(false);
    if (errorCb) errorCb(err);
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* getVendorDataById({ data: { vendorId, cb, errorCb } }) {
  try {
    const { url, method } = VENDOR_DATA_BY_ID_URL;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    const options = { method };
    const response = yield call(request, updatedUrl, options);
    yield put(saveVendorDataByIdAction(response));
    if (cb) cb(response);
  } catch (err) {
    if (errorCb) errorCb();
    else {
      yield put(disableLoaderAction());
      yield put(showToast(err));
    }
  }
}

export function* getVendorOdBalance({ data }) {
  const {
    successCb,
    errorCb,
    nextSettlementDate,
    resetLoader,
    ...queryObj
  } = data;
  try {
    const { url, method } = GET_VENDOR_OD_BALANCE_URL;
    const options = {
      method,
      queryString: queryObj || {},
    };

    const response = yield call(request, url, options);

    if (response && +response.existingVendorBalance >= MINIMUM_VENDOR_BALANCE) {
      successCb({
        ...response,
        nextSettlementDate,
        merchantVendorId: queryObj.merchantVendorId,
      });
    } else
      yield put(
        showToast({
          message:
            'On Demand amount for the interval can not be less than Rs 1000',
        }),
      );
  } catch (err) {
    errorCb();
    yield put(showToast(err));
  } finally {
    resetLoader(false);
  }
}

export function* initiateVendorOd({ data }) {
  const { successCb, errorCb, ...body } = data;
  try {
    const { url, method } = INITIATE_VENDOR_OD_URL;
    const options = {
      method,
      body: JSON.stringify(body),
    };

    const response = yield call(request, url, options);

    successCb(response);
  } catch (err) {
    errorCb();
    yield put(showToast(err));
  }
}

export function* getBusinessInfo({ data: { vendorId, updatedBy, cb } }) {
  try {
    const { url, method } = UPDATE_VENDOR_URL_NEW;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    const options = { method, body: JSON.stringify({ updatedBy }) };
    const response = yield call(request, updatedUrl, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}
export function* getVendorKycDocs({ data: { vendorId, cb } }) {
  try {
    const { url, method } = GET_VENDOR_KYC_DOCS_URL;
    const updatedUrl = url.replace(`$vendor_id$`, vendorId);
    const options = { method };
    const response = yield call(request, updatedUrl, options);
    if (cb) cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getDocsByUser({ data: { userName, cb, actions } }) {
  try {
    const { url, method } = GET_DOCS_BY_USER_URL;
    const options = {
      method,
    };
    const updatedUrl = url.replace('$userName$', userName);
    // clear the old data first
    yield put(saveVendorDocsAction({}));
    const response = yield call(request, updatedUrl, options);
    // console.log('response is - ', response);
    yield put(saveVendorDocsAction(response));

    if (cb) cb(response?.documents);
  } catch (err) {
    yield put(saveVendorDocsAction({}));
    if (actions) actions.setSubmitting(false);
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* uploadVendorDocs({ data }) {
  try {
    const promiseArr = [];
    const {
      userName,
      // userAccountType,
      // userBusinessType,
      payload,
      docNameTypeMapping,
      cb,
      updatedBy,
    } = data;
    const { url, method } = UPLOAD_VENDOR_DOCS_URL;
    const options = {
      method,
      // queryString: { userAccountType, userBusinessType },
    };
    const updatedUrl = url.replace('$userName$', userName);

    if (payload) {
      const inputKeys = Object.keys(payload.inputs);
      const fileKeys = Object.keys(payload.docs);

      inputKeys.forEach(key => {
        const docName = key;
        const docValue = payload.inputs[docName];
        const formData = new FormData();
        formData.append('docName', docName);
        formData.append('docValue', docValue);
        formData.append('docCategory', docNameTypeMapping[docName]);
        // formData.append('docType', docName);
        formData.append('updatedBy', updatedBy);
        promiseArr.push(
          // eslint-disable-next-line redux-saga/yield-effects
          call(request, updatedUrl, { ...options, body: formData }),
        );
      });

      fileKeys.forEach(key => {
        const docName = key;
        const file = payload.docs[docName];
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('docCategory', docNameTypeMapping[docName]);
        formData.append('docType', docNameTypeMapping[docName]);
        formData.append('updatedBy', updatedBy);
        formData.append('docName', docName);
        promiseArr.push(
          // eslint-disable-next-line redux-saga/yield-effects
          call(request, updatedUrl, { ...options, body: formData }),
        );
      });
      yield all(promiseArr);
    }
    if (cb) cb();
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* verifyPan({ data }) {
  try {
    const { payload, extractGSTIN, cb, loadingFn } = data;
    const { url, method } = VERIFY_PAN_URL;
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    loadingFn();
    const response = yield call(request, url, options);
    const { isValid, isNameMatchSuccessful } = response;

    // check if the document is verified
    // if yes then call the get all user docs api
    if (isValid && isNameMatchSuccessful) {
      const updatedUrl = GET_DOCS_BY_USER_URL.url.replace(
        '$userName$',
        payload.userName,
      );
      const result = yield call(request, updatedUrl, {
        method: GET_DOCS_BY_USER_URL.method,
      });
      extractGSTIN(result);
    }
    if (cb) cb(response);
  } catch (err) {
    if (data.errorCb) data.errorCb();
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* verifyCin({ data }) {
  try {
    const { payload, cb, loadingFn } = data;
    const { url, method } = VERIFY_CIN_URL;
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    loadingFn();
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    if (data.errorCb) data.errorCb();
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* verifyGst({ data }) {
  try {
    const { payload, cb, loadingFn } = data;
    const { url, method } = VERIFY_GST_URL;
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    loadingFn();
    const response = yield call(request, url, options);
    if (cb) cb(response);
  } catch (err) {
    if (data.errorCb) data.errorCb();
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* createOnboardingUser({ data }) {
  try {
    const { payload, cb } = data;
    const { url, method } = CREATE_ONBOARDING_USER_URL;
    const options = {
      method,
      body: JSON.stringify(payload),
    };
    yield call(request, url, options);
    if (cb) cb();
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* searchEasySplitSaga() {
  yield takeEvery(SEARCH_VENDORS, searchEasySplitVendors);
}

export function* settlementConfigSaga() {
  yield takeEvery(SETTLEMENT_CONFIG, getSettlementConfig);
}

export function* createVendorSaga() {
  yield takeEvery(CREATE_VENDOR, createVendor);
}

export function* updateVendorSaga() {
  yield takeEvery(UPDATE_VENDOR, updateVendor);
}

export function* createVendorNewSaga() {
  yield takeEvery(CREATE_VENDOR_NEW, createVendorNew);
}
export function* updateVendorNewSaga() {
  yield takeEvery(UPDATE_VENDOR_NEW, updateVendorNew);
}

export function* batchUploadSubmitSaga() {
  yield takeEvery(BATCH_UPLOAD_SUBMIT, batchUploadSubmit);
}

export function* batchDownloadSaga() {
  yield takeEvery(BATCH_DOWNLOAD, batchDownload);
}

export function* getVendorDataByIdSaga() {
  yield takeEvery(VENDOR_DATA_BY_ID, getVendorDataById);
}

export function* getVendorOdBalanceSaga() {
  yield takeEvery(GET_VENDOR_OD_BALANCE, getVendorOdBalance);
}

export function* initiateVendorOdSaga() {
  yield takeEvery(INITIATE_VENDOR_OD, initiateVendorOd);
}

export function* downloadDocSaga() {
  yield takeEvery(DOWNLOAD_DOC, downloadDoc);
}

export function* createKycSaga() {
  yield takeEvery(CREATE_KYC, createKyc);
}
export function* getVendorKycDocsSaga() {
  yield takeEvery(GET_VENDOR_KYC_DOCS, getVendorKycDocs);
}
export function* getBusinessInfoSaga() {
  yield takeEvery(GET_BUSINESS_INFO, getBusinessInfo);
}

export function* getDocsByUserSaga() {
  yield takeEvery(GET_DOCS_BY_USER, getDocsByUser);
}

export function* uploadVendorDocsSaga() {
  yield takeEvery(UPLOAD_VENDOR_DOCS, uploadVendorDocs);
}

export function* verifyPanSaga() {
  yield debounce(500, VERIFY_PAN, verifyPan);
}

export function* verifyGstSaga() {
  yield debounce(500, VERIFY_GST, verifyGst);
}

export function* verifyCinSaga() {
  yield debounce(500, VERIFY_CIN, verifyCin);
}

export function* createOnboardingUserSaga() {
  yield takeEvery(CREATE_ONBOARDING_USER, createOnboardingUser);
}

// Individual exports for testing
export default function* easySplitSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    searchEasySplitSaga,
    batchUploadSubmitSaga,
    batchDownloadSaga,
    createVendorSaga,
    updateVendorSaga,
    createVendorNewSaga,
    updateVendorNewSaga,
    settlementConfigSaga,
    getVendorDataByIdSaga,
    getVendorOdBalanceSaga,
    initiateVendorOdSaga,
    createKycSaga,
    downloadDocSaga,
    getVendorKycDocsSaga,
    getBusinessInfoSaga,
    getDocsByUserSaga,
    uploadVendorDocsSaga,
    verifyCinSaga,
    verifyGstSaga,
    verifyPanSaga,
    createOnboardingUserSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
